module.exports = __webpack_public_path__ + "img/about-5.92e84bfc.jpg";